// extracted by mini-css-extract-plugin
module.exports = {"squareWrapper":"RoundImage-module--squareWrapper--1QZkX","roundImage":"RoundImage-module--roundImage--3FKx7"};